import apiClient from './apiClient';



// ==================== CLIENT APIs ====================



export const getAllClientFormats = async (page = 1, limit = 10, search = "", filters = {}) => {
  let url = `/client-format/all?page=${page}&limit=${limit}`;
  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }
  if (filters.clientName) {
    url += `&clientName=${encodeURIComponent(filters.clientName)}`;
  }
  if (filters.startDate) {
    url += `&startDate=${encodeURIComponent(filters.startDate)}`;
  }
  if (filters.endDate) {
    url += `&endDate=${encodeURIComponent(filters.endDate)}`;
  }
  const response = await apiClient.get(url);
  return response.data;
};

export const getClientFormatById = async (id) => {
  const response = await apiClient.get(`/client-format/${id}`);
  return response.data;
};

export const uploadClientTripSheet = async (file, clientId, fromDate = '', toDate = '') => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('clientId', clientId);
  if (fromDate) formData.append('fromDate', fromDate);
  if (toDate) formData.append('toDate', toDate);

  const response = await apiClient.post('/client-format/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};

export const uploadGlobalTripSheet = async (file, fromDate = '', toDate = '') => {
  const formData = new FormData();
  formData.append('file', file);
  if (fromDate) formData.append('fromDate', fromDate);
  if (toDate) formData.append('toDate', toDate);

  const response = await apiClient.post('/client-format/upload-global', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};

export const createClientFromSheet = async (file) => {

  const formData = new FormData();

  formData.append('Clients sheet1', file);



  const response = await apiClient.post('/client/upload-sheet', formData, {

    headers: {

      'Content-Type': 'multipart/form-data',

    },

  });



  return response.data;

};



export const createClient = async (clientData) => {

  const response = await apiClient.post('/client/create', clientData);

  return response.data;

};



export const getAllClients = async (page = 1, limit = 1000, search = "") => {
  let url = `/client/getall?page=${page}&limit=${limit}`;
  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }
  const response = await apiClient.get(url);
  return response.data;
};



export const getClientById = async (id) => {

  const response = await apiClient.get(`/client/get/${id}`);

  return response.data;

};



export const updateClient = async (id, clientData) => {

  const response = await apiClient.put(`/client/update/${id}`, clientData);

  return response.data;

};



export const deleteClient = async (id) => {

  const response = await apiClient.delete(`/client/delete/${id}`);

  return response.data;

};



export const toggleClientStatus = async (id) => {

  const response = await apiClient.put(`/client/toggle-status/${id}`);

  return response.data;

};



export const createClientManual = async (clientData) => {

  const payload = {

    clientName: clientData.name,

    contactPerson: clientData.contactPerson,

    contactNumber: clientData.contactNumber,

    address: clientData.location,

    email: clientData.email || ''

  };

  const response = await apiClient.post('/client/create', payload);

  return response.data;

};



// ==================== SLAB APIs ====================



export const createSlab = async (slabData) => {

  const response = await apiClient.post('/client/create-slab', slabData);

  return response.data;

};



export const getAllSlabs = async (filters = {}) => {

  const { clientId, slabType, startRange, endRange, vehicleType } = filters;

  const params = new URLSearchParams();

  

  if (clientId) params.append('clientId', clientId);

  if (slabType) params.append('slabType', slabType);

  if (startRange) params.append('startRange', startRange);

  if (endRange) params.append('endRange', endRange);

  if (vehicleType) params.append('vehicleType', vehicleType);

  

  const queryString = params.toString();

  const url = queryString ? `/client/getall-slab?${queryString}` : '/client/getall-slab';

  

  const response = await apiClient.get(url);

  return response.data;

};



export const getSlabById = async (id) => {

  const response = await apiClient.get(`/client/get-slab/${id}`);

  return response.data;

};



export const updateSlab = async (id, slabData) => {

  const response = await apiClient.put(`/client/update-slab/${id}`, slabData);

  return response.data;

};



export const deleteSlab = async (id) => {

  const response = await apiClient.delete(`/client/delete-slab/${id}`);

  return response.data;

};



// ==================== RATE CARD APIs ====================



export const createRateCard = async (rateCardData) => {

  const response = await apiClient.post('/client/create-rate-card', rateCardData);

  return response.data;

};



export const getAllRateCards = async (filters = {}) => {

  const { clientId, vehicleType } = filters;

  const params = new URLSearchParams();

  

  if (clientId) params.append('clientId', clientId);

  if (vehicleType) params.append('vehicleType', vehicleType);

  

  const queryString = params.toString();

  const url = queryString ? `/client/getall-rate-card?${queryString}` : '/client/getall-rate-card';

  

  const response = await apiClient.get(url);

  return response.data;

};



export const getRateCardById = async (id) => {

  const response = await apiClient.get(`/client/get-rate-card/${id}`);

  return response.data;

};



export const updateRateCard = async (id, rateCardData) => {

  const response = await apiClient.put(`/client/update-rate-card/${id}`, rateCardData);

  return response.data;

};



export const deleteRateCard = async (id) => {

  const response = await apiClient.delete(`/client/delete-rate-card/${id}`);

  return response.data;

};



const createClientApi = {

  // Client

  uploadClientTripSheet,

  createClientFromSheet,

  createClient,

  createClientManual,

  getClientById,

  updateClient,

  deleteClient,

  // Slab

  createSlab,

  getAllSlabs,

  getSlabById,

  updateSlab,

  deleteSlab,

  // Rate Card

  createRateCard,

  getAllRateCards,

  getRateCardById,

  updateRateCard,

  deleteRateCard,

};

export default createClientApi;

